import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsFnService {
  private renderer: Renderer2;
  constructor(
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  keypressNumber(event: any) {
    if ( event.target.value.length >= 50 ) {
      return false
    }
    const keycode = event.which
    if((keycode >= 48 && keycode <= 57) || keycode == 8 ) {
      return true
    }
    return false
  }

  setTargetValue(e: any, charCode: any): any {
    if ( e.target.value.length >= 3 ) {
      e.target.value = ''
    }
    if ( e.target.value.length === 0 && charCode === 44 ) {
      e.target.value = e.target.value + '1'
    }
    if ( e.target.value.length === 1 && charCode !== 44 ) {
      e.target.value = e.target.value + ','
    }
    return e.target.value
  }

  allowNumericDigitsOnlyOnKeyUp(e: any, indexBody: number, i: number, row: any) {
    const charCode = e.which ? e.which : e.keyCode

    if (charCode === 13) { // Enter
      e.preventDefault()
      document.getElementById(`input-calificacion-${indexBody+1}-${i}`)?.focus()
      return
    }

    if (charCode > 31 && charCode !== 44 && (charCode < 48 || charCode > 57)) {
      e.preventDefault()
      return
		}
    if ( e.target.value.length === 2 && charCode === 44 ) {
      e.preventDefault()
      return
    }
    
    e.target.value = this.setTargetValue(e, charCode)

    if ( e.target.value.length === 0 && (charCode === 56 || charCode === 57 || charCode === 48) ) {
      e.preventDefault()
      return
    }

    if ( e.target.value.length === 2 && e.target.value === '7,' && charCode !== 48 ) {
      e.preventDefault()
      return
    }

    if ( e.target.value.length === 2 && !e.target.value.includes(',') ) {
      e.target.value = e.target.value[0] + ',' + e.target.value[1]
    }
  }

  focusOut(e: any, indexBody: number, i: number, row: any) {
    if ( e.target.value.length === 1 && !isNaN(e.target.value) ) {
      e.target.value = e.target.value + ',0'
    }
    if ( e.target.value.length === 2 && e.target.value[1] === ',' ) {
      e.target.value = e.target.value[0] + ',0'
    }
    if ( e.target.value[0] === '0' && e.target.value !== '0,0' ) {
      e.target.value = '1,0'
    }
    if ( e.target.value.length === 0 ) {
      e.target.value = '0,0'
    }
  }

  loaderElement: any
  agregarLoader(idTabla: string): void {
    const filterElement = document.getElementById(`${idTabla}_filter`);
    if (filterElement) {
      const existingLoader = filterElement.querySelector('.lds-roller');
      
      if (!existingLoader) { // Si no existe, agregar el loader
        const loaderDiv = this.renderer.createElement('div');
        this.renderer.addClass(loaderDiv, 'lds-roller');

        for (let i = 0; i < 8; i++) {
          const childDiv = this.renderer.createElement('div');
          this.renderer.appendChild(loaderDiv, childDiv);
        }

        this.renderer.appendChild(filterElement, loaderDiv);
        this.loaderElement = loaderDiv;
      }
    }
  }

  eliminarLoader(idTabla: string): void {
    const filterElement = document.getElementById(`${idTabla}_filter`);
    if (filterElement && this.loaderElement) {
      this.renderer.removeChild(filterElement, this.loaderElement);
      this.loaderElement = null;
    }
  }
}
